var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgY(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1499 5.1123H9.5699C17.1202 5.1123 23.2499 10.3514 23.2499 16.8046V26.6981H19.8299C12.2796 26.6981 6.1499 21.4591 6.1499 15.0058V5.1123Z",
    fill: "url(#paint0_linear_16367_8823)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.93 5.1123H43.35V30.5333C43.35 37.3518 37.2203 42.8875 29.67 42.8875H26.25V17.4664C26.25 10.6479 32.3797 5.1123 39.93 5.1123Z",
    fill: "url(#paint1_linear_16367_8823)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16367_8823",
    x1: 9.40679,
    y1: 5.18201,
    x2: 17.8431,
    y2: 28.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33EACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#42CCCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5C9BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6F78C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7A62C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F5BC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16367_8823",
    x1: 42.2661,
    y1: 13.8434,
    x2: 31.8363,
    y2: 31.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BB3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787BD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgY);
export default __webpack_public_path__ + "static/media/y.420756a6f1e36b03a60ecd50091061a3.svg";
export { ForwardRef as ReactComponent };